import React from 'react';
import {
  Breadcrumb,
  Layout,
  notification,
  Modal,
  Col,
  Row,
  Select,
  Button,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

const { Option } = Select;

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import updateTipoSelloPorId from '../../../../graphql/mutations/otros/updateTipoSelloPorId.graphql';
import getTipoSelloPorId from '../../../../graphql/querys/otros/getTipoSelloPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
  paddingBottom: 20,
};

@graphql(updateTipoSelloPorId, {
  name: 'updateTipoSelloPorId',
})
class EditarTipoSello extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      tipo_sello: {},
      tramites: [],
    };

    this.props.client
      .query({
        query: getTipoSelloPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const tipoSello = res.data.getTipoSelloPorId;

        this.setState({
          loading: false,
          tipo_sello: tipoSello,
          tramites: tipoSello.tramites ? tipoSello.tramites : [],
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });

        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  guardar = e => {
    e.preventDefault();

    const objUpdate = { tramites: this.state.tramites };

    this.setState({ loading: true });
    this.props
      .updateTipoSelloPorId({
        variables: {
          _id: this.props.match.params.id,
          nuevaTipo_Sello: objUpdate,
        },
      })
      .then(res => {
        notification.success({
          message: 'Actualizacion Correcta',
          description: 'Se ha registrado los nuevos datos de la tasa',
        });

        this.setState(
          {
            loading: false,
          },
          () => this.props.history.push('/admin/otros/tipo_sello')
        );
      })
      .catch(err => {
        console.log('Error en la actualizacion de la tasa', err);
        this.setState({ loading: false });

        Modal.error({
          title: 'Error en la actualizacion de la tasa',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  onCancel = () => {
    this.props.history.push('/admin/otros/tipo_sello');
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { usuario } = this.props;

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Categoria</Breadcrumb.Item>
          <Breadcrumb.Item>Configurar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Configurar Tasa
          </h2>
          <br />
          <div style={estiloContent}>
            <Form onSubmit={this.guardar}>
              <Row type="flex" justify="center">
                <div style={{ paddingRight: 20, marginBottom: 10 }}>
                  <h2>Tasa ${this.state.tipo_sello.valor} </h2>
                </div>
              </Row>
              <Row type="flex" justify="center">
                <Col span={2}>
                  <h3>Tramites: </h3>
                </Col>
                <Col span={6}>
                  <Select
                    allowClear
                    mode="multiple"
                    id="tramites"
                    value={this.state.tramites}
                    placeholder="Selecciones los tramites"
                    onChange={selectedTramites =>
                      this.setState({
                        tramites: selectedTramites,
                      })
                    }
                  >
                    <Option value="CERTIFICACIONES">Certificaciones</Option>
                    <Option value="ACREDITACIONES">Acreditaciones</Option>
                    <Option value="DECLARACIONES JURADAS">
                      Declaracion Jurada
                    </Option>
                    <Option value="INFORMACIONES SUMARIAS">
                      Informacion Sumaria
                    </Option>
                    <Option value="AUTORIZACIONES MENORES">
                      Autorizaciones Menores
                    </Option>
                    <Option value="AUTORIZACIONES OTRAS">
                      Autorizaciones Otras
                    </Option>
                    <Option value="ACUERDOS EXTRAJUDICIALES">
                      Acuerdos Extrajudiciales
                    </Option>
                  </Select>
                </Col>
                <Col span={2} offset={2}>
                  <Button type="primary" htmlType="submit">
                    Guardar
                  </Button>
                </Col>
                <Col span={2}>
                  <Button type="danger" onClick={this.onCancel}>
                    Cancelar
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarTipoSello);
